module.exports = __webpack_public_path__ + "assets/events_blue.339a702a.svg";